// Utility functions for routing

// These patterns match paths that should use Turbo routing instead of Vue Router
export const excludePatterns = [
  /\/customers\/\d+\/addresses\/\d+/,
  /\/qbo\/oauth/,
  /\/timeout/,
  /\/quotes\/\d+\/edit/,
  /\/v2\/customers\/\d+\/quotes\/\d+\/pdf/,
  /\/invoices\/\d+\/(pdf|edit)/,
  /internal\./,
  /\/inventory/,
  /\/admin\/v4/,
  /\/tax_zones/,
  /\/tax_exemption_reasons/,
  /\/admins\//,
  /\/vehicles(\/(new|\d+(\/edit)?))/,
  /\/departments\/(?!\d+\/works_crews$).*/,
  /\/services/,
  /\/permits/,
  /\/technicians/,
  /\/technician_mergers\/new/,
  /\/data_load/,
  /\/data_wipe/,
  /\/accounting\/qbo_support/,
  /^\/batches\/\d+/,
  /\/internal_settings/,
  /\/employees/,
  /\/roles/,
  /\/coverage_areas(\/(new|\d+(\/edit)?))/,
  /\/interested_customers(\/(new|\d+(\/edit)?))/,
  /\/discounts(\/(new|\d+(\/edit)?))/,
  /\/email_content_editor/,
  /\/reports\/tech_call_history/,
  /\/reports\/quoted_line_items/,
  /\/users\/password/,
  /\/users\/set_password_confirmation/
];

/**
 * Checks if a path should be excluded from Vue Router handling
 * @param path - The path to check
 * @returns boolean - True if the path should use regular anchor tag, false for RouterLink
 */
export const isExcludedPath = (path: string): boolean => {
  return excludePatterns.some((regex) => regex.test(path));
};
